<div [formGroup]="form">
  <div class="header">
    <span
      class="title-row"
      mattooltip="Incoterm determines who will pay for customers, the buyer or the seller"
      matTooltipClass="pdq-mat-tooltip">
      Incoterm</span
    >
    <span class="grey-description">Choose who pays duties and taxes</span>
  </div>
  <pdq-dropdown
    [formControlName]="fields.incoterm.name"
    class="distance-unit"
    fullWidth="true"
    [options]="dutiesOptions"
    (onChange)="onDutiesResChecked($event.value)"
    placeholder="Choose incoterm"
    [invalid]="isControlInvalid(fields.incoterm.name)"
    [invalidMsg]="fields.incoterm.validationMsg"
    required="true">
  </pdq-dropdown>
  <div class="settings-row">
    <span class="field-label">{{ fields.nonDeliveryOption.label }}</span>
    <pdq-dropdown
      [formControlName]="fields.nonDeliveryOption.name"
      class="distance-unit"
      fullWidth="true"
      [options]="fields.nonDeliveryOption.options">
    </pdq-dropdown>
  </div>
  <div class="settings-row">
    <span class="field-label">{{ fields.contentsType.label }}</span>
    <pdq-dropdown
      [formControlName]="fields.contentsType.name"
      class="distance-unit"
      fullWidth="true"
      (onChange)="onContentsTypeChanged($event)"
      [options]="fields.contentsType.options">
    </pdq-dropdown>
  </div>
  @if (this.form.get(fields.contentsType.name)?.value === 'other') {
    <div class="settings-row">
      <span class="field-label">{{ fields.contentsTypeDescription.label }}</span>
      <pdq-textarea
        [control]="this.form.get(fields.contentsTypeDescription.name)"
        maxLength="255"
        [invalidMessage]="
          this.form.get(fields.contentsTypeDescription.name)?.errors?.required ? 'Description is required' : ''
        "
        placeholder="Enter description">
      </pdq-textarea>
    </div>
  }
  <div class="settings-row">
    <span class="field-label">{{ fields.merchandiseCategory.label }}</span>
    <pdq-dropdown
      [formControlName]="fields.merchandiseCategory.name"
      class="distance-unit"
      label="Default product category"
      fullWidth="true"
      [options]="fields.merchandiseCategory.options"
      (onChange)="onCategoryChanged($event.value)"
      placeholder="Choose category"
      [invalid]="isControlInvalid(fields.merchandiseCategory.name)"
      [invalidMsg]="fields.merchandiseCategory.validationMsg"
      required="true">
    </pdq-dropdown>
  </div>
  <div class="settings-row">
    <pdq-input
      [formControlName]="fields.certifiedSigner.name"
      [label]="fields.certifiedSigner.label"
      [placeholder]="fields.certifiedSigner.placeholder"
      [tooltip]="fields.certifiedSigner.tooltip"
      [invalid]="isControlInvalid(fields.certifiedSigner.name)"
      [invalidMsg]="fields.certifiedSigner.validationMsg"
      required="true"
      variant="form"></pdq-input>
  </div>
</div>
